import React from "react";
var __jsx = React.createElement;
var StarSVG = function StarSVG(_ref) {
  var _ref$filledColor = _ref.filledColor,
    filledColor = _ref$filledColor === void 0 ? "#F1B85B" : _ref$filledColor;
  return /*#__PURE__*/React.createElement("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9797 14.8764C28.4728 14.3959 28.6468 13.6906 28.4341 13.035C28.221 12.3794 27.6657 11.9114 26.9835 11.8121L20.918 10.9307C20.6597 10.8931 20.4365 10.7311 20.3211 10.4968L17.6094 5.00121C17.3049 4.38373 16.6869 4 15.9982 4C15.31 4 14.692 4.38373 14.3876 5.00121L11.6754 10.4973C11.56 10.7316 11.3363 10.8936 11.078 10.9312L5.01249 11.8126C4.33081 11.9114 3.77502 12.3799 3.56184 13.0355C3.34916 13.6911 3.52321 14.3964 4.0163 14.8769L8.40488 19.1546C8.59198 19.3372 8.67775 19.6 8.63361 19.8569L7.59829 25.8973C7.50649 26.429 7.64594 26.9461 7.99005 27.3539C8.52476 27.9895 9.45826 28.1831 10.2047 27.7908L15.6291 24.9387C15.8558 24.8198 16.1412 24.8208 16.3674 24.9387L21.7923 27.7908C22.0562 27.9298 22.3376 28 22.628 28C23.1582 28 23.6608 27.7642 24.0064 27.3539C24.351 26.9461 24.49 26.428 24.3982 25.8973L23.3624 19.8569C23.3182 19.5995 23.404 19.3372 23.5911 19.1546L27.9797 14.8764Z",
    fill: filledColor
  }));
};
export default StarSVG;